export default __webpack_public_path__ + "static/media/logo.46cb1bac.png";